import styled from '@emotion/styled';
import type { FC } from 'react';
import { useInspectedTracker } from '../../../lib/customHooks';
import { TrackerEventsTable } from '../TrackerEventsTable';

export const EventsTab: FC = () => {
  const inspectedTracker = useInspectedTracker();
  const eventIds = new Set(
    inspectedTracker?.eventIds?.map((eventId) => eventId.toHexString()) || [],
  );

  const { owner, borrowers, editors } = inspectedTracker || {};
  const now = new Date();

  const validBorrowers = (borrowers || []).filter((borrower) => {
    return borrower.endTime < now;
  });

  const associatedUsers = new Set([
    ...validBorrowers.map((borrower) => borrower.id.toHexString()),
    ...(owner ? [owner.toHexString()] : []),
    ...(editors || []).map((editor) => editor.toHexString()),
  ]);

  return (
    <Container>
      <TrackerEventsTable
        eventIds={eventIds}
        trackId={inspectedTracker?.trackerId}
        associatedUsers={associatedUsers}
      />
    </Container>
  );
};

const Container = styled.div`
  .nav-item,
  .nav {
    border-color: darkgray;
  }

  .nav-link {
    padding: 0.2rem 0.5rem;
  }
`;
